export const InputActionId = {
    GeneralOpenKeyBindingPanel: 'general-open-key-binding-panel',
    GeneralOpenProjects: 'general-open-projects',
    GeneralCancel: 'general-cancel',
    GeneralSave: 'general-save',
    GeneralToggleViewMode: 'general-toggle-view-mode',
    GeneralToggleCopilot: 'general-toggle-copilot',

    CameraCenter: 'camera-center',
    CameraLockToggle: 'camera-lock-toggle',
    CameraUnlockToggle: 'camera-unlock-toggle',
    CameraRotate: 'camera-rotate',
    CameraTruck: 'camera-truck',
    CameraZoom: 'camera-zoom',

    PoiNavigationModeToggle: 'poi-navigation-mode-toggle',
    PoiNavigationTemporary: 'poi-navigation-temporary',
    PoiPrevious: 'poi-previous',
    PoiNext: 'poi-next',
    PoiSwitchType: 'poi-switch-type',
    PoiSwitchTypeReversed: 'poi-switch-type-reversed',
    PoiToggleCameraRealignment: 'poi-toggle-camera-realignment',
    PoiSelect: 'poi-select',
    PoiSelectAndAlign: 'poi-select-and-align',

    ArticleCopy: 'article-copy',
    ArticleCut: 'article-cut',
    ArticlePaste: 'article-paste',
    ArticleDelete: 'article-delete',
    ArticleSelectAll: 'article-select-all',
    ArticleTransform: 'article-transform',
    ArticleRotate: 'article-rotate',
    ArticleQuickReplacement: 'article-quick-replacement',
    ArticleQuickReplacementLeft: 'article-quick-replacement-left',
    ArticleQuickReplacementRight: 'article-quick-replacement-right',
    ArticleQuickReplacementUp: 'article-quick-replacement-up',
    ArticleQuickReplacementDown: 'article-quick-replacement-down',
    ArticleQuickReplacementInwardModifier: 'article-quick-replacement-inward-modifier',
    ArticleGroup: 'article-group',
    ArticleUngroup: 'article-ungroup',
    ArticleShowContextMenu: 'article-show-context-menu',
    ArticleCatalogueDrag: 'article-catalogue-drag',

    SelectionBoxFullyEnclosed: 'selection-box-fully-enclosed',
    SelectionBoxPartiallyEnclosed: 'selection-box-partially-enclosed',
    SelectionBoxRecursive: 'selection-box-recursive',

    PlacementExecute: 'placement-execute',
    PlacementApplySelectedSolution: 'placement-apply-selected-solution',
    PlacementListNavigationUp: 'placement-list-navigation-up',
    PlacementListNavigationDown: 'placement-list-navigation-down'
} as const;

export type InputActionId = (typeof InputActionId)[keyof typeof InputActionId];
